import React, { useState } from 'react'
import arrowBelow from '../../assets/img/icon/arrow-below.png';
import arrowRight from '../../assets/img/icon/arrow-right.svg';
import { FiHome } from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';
import { SlHome } from "react-icons/sl";

const FamilyPlazaSubHeading = ({ heading }) => {
    const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const handleMobileNavToggle = () => {
        setIsMobileNavOpen(!isMobileNavOpen);
    };

    const handleMobileNavItemClick = (item) => {
        setIsMobileNavOpen(false);
        // Handle navigation based on item
        navigate(`/${item}`);
    };

    return (
        <>
            {/* Page Header */}
            <div className={`page-header ${isMobileNavOpen ? 'mobile-menu-open' : ''}`}>
                <div className="page-title-section">
                    <div className="title-line"></div>
                    <div className="title-content">
                        <h1 className="page-title">{heading}</h1>
                    </div>
                </div>
                <div className="breadcrumb-navigation">
                    <span className="breadcrumb-item">
                        <SlHome size={16} />
                    </span>
                    <span className="breadcrumb-separator">|</span>
                    <span className="breadcrumb-item">유족광장</span>
                    <span className="breadcrumb-separator">|</span>
                    <span className="breadcrumb-item active">{heading}</span>
                </div>

                <div className="mobile-navigation-section">
                    <img src={arrowBelow} alt="mobile-nav-icon" onClick={handleMobileNavToggle} className={isMobileNavOpen ? 'active' : ''} />
                </div>

            </div>

            {/* Mobile Navigation */}
            {isMobileNavOpen && (
                <div className="mobile-navigation">

                    <div className="mobile-nav-items">
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('cyber-memorial-search') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('cyber-memorial-search')}
                        >
                            <span>사이버추모관</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('letter-to-heaven-board-list') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('letter-to-heaven-board-list')}
                        >
                            <span>하늘로 보내는 편지</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('management-fee-payment-inquiry') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('management-fee-payment-inquiry')}
                        >
                            <span>관리비 납부 조회</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('ancestral-tablet') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('ancestral-tablet')}
                        >
                            <span>지방출력</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                    </div>

                </div>
            )}
        </>
    )
};

export default FamilyPlazaSubHeading;
